<template>
    <div class="flex text-sm justify-between pb-2 font-semibold mb-3 mt-6 border-b" :class="border">
        <template v-if="$slots.default">
            <slot></slot>
        </template>
        <template v-else>
            <div>
                <slot name="left"></slot>
            </div>
            <div class="text-primary-500">
                <slot name="right"></slot>
            </div>
        </template>
    </div>
</template>
<script>
    export default {
        props: {
            border: {
                type: String,
                default: 'border-b'
            }
        }
    }
</script>
